// extracted by mini-css-extract-plugin
export var cardHeader = "_e2-0";
export var reorderHandle = "_e2-3";
export var titleArea = "_e2-1";
export var titleAreaWithHandle = "_e2-2";